import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import MicroIcon from "../brand/MicroIcon";
import { COLORS, SITE } from "../brand/tokens";

const SiteHeader = () => {
  const loc = useLocation();
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => { setOpen(false); }, [loc.pathname]);

  const links = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/walk", label: "The Walk" },
    { to: "/shop", label: "Shop" },
    { to: "/journal", label: "Journal" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="site-header" data-testid="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-brand" data-testid="site-brand-link">
          <MicroIcon size={34} color={COLORS.gold} />
          <span className="site-brand__name">Rona Wellness</span>
        </Link>

        <nav className={`site-nav ${open ? "site-nav--open" : ""}`} data-testid="site-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) => "site-nav__link" + (isActive ? " is-active" : "")}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={SITE.shops.etsy}
            target="_blank"
            rel="noreferrer"
            className="site-nav__cta"
            data-testid="nav-shop-etsy"
          >
            Shop on Etsy →
          </a>
        </nav>

        <button
          className="site-header__toggle"
          onClick={() => setOpen((o) => !o)}
          data-testid="site-header-toggle"
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
};

export default SiteHeader;
